import type { FeatureToggles } from '@makemydeal/dr-platform-shared';
import type { AnyAction } from 'redux';
import * as types from '../types/actionTypes';
import { getLoadPayloadFeatureToggles } from '../utils/loadPayloadFeatureToggles';
import { initialState } from './initialState';

export const featureToggles = (state: FeatureToggles | undefined = initialState.featureToggles, action: AnyAction) => {
    switch (action.type) {
        case types.INIT_INVALID_OFFER:
        case types.INIT_SUCCESS:
        case types.INIT_PENCIL_SUCCESS:
            return { ...state, ...getLoadPayloadFeatureToggles(action.payload) };
        default:
            return state;
    }
};

export const shouldDisplayZipModal = (state: boolean | undefined = initialState.shouldDisplayZipModal, action: AnyAction) => {
    switch (action.type) {
        case types.INIT_SUCCESS: {
            return action.payload.offer.shouldDisplayZipModal || false;
        }
        default: {
            return state;
        }
    }
};

export const toggles = (state: FeatureToggles | undefined = initialState.toggles, action: AnyAction) => {
    switch (action.type) {
        case types.INIT_OFFER:
            return { ...state, ...action.payload.toggles };
        case types.SYNC_MESSAGE:
            return { ...state, ...action.message.toggles };
        default:
            return state;
    }
};
